import { useTranslation } from 'react-i18next';
import { REG_FONTS } from './styles';

interface Badge {
  emoji: string;
  bgColor: string;
  titleKey: string;
  descKey: string;
}

const badges: Badge[] = [
  { emoji: '🔒', bgColor: 'bg-[#e3f2fd]', titleKey: 'trust.data_title', descKey: 'trust.data_desc' },
  { emoji: '⚖️', bgColor: 'bg-[#f3e5f5]', titleKey: 'trust.lawyers_title', descKey: 'trust.lawyers_desc' },
  { emoji: '✅', bgColor: 'bg-[#e8f5e9]', titleKey: 'trust.free_title', descKey: 'trust.free_desc' },
  { emoji: '🔐', bgColor: 'bg-[#fff3e0]', titleKey: 'trust.secure_title', descKey: 'trust.secure_desc' },
];

export function TrustBadges() {
  const { t } = useTranslation('regularizacion');

  return (
    <section className="mt-8 animate-fadeUp">
      <h2
        className="text-center text-xl font-bold text-[#1a1a1a] mb-5"
        style={{ fontFamily: REG_FONTS.heading }}
      >
        {t('trust.title')}
      </h2>

      <div className="grid grid-cols-2 max-sm:grid-cols-1 gap-4">
        {badges.map((badge) => (
          <div
            key={badge.titleKey}
            className="flex items-start gap-3 bg-white rounded-2xl p-4 shadow-[0_2px_12px_rgba(0,0,0,0.06)] hover:-translate-y-0.5 hover:shadow-[0_4px_16px_rgba(0,0,0,0.1)] transition-all duration-200 cursor-default"
          >
            <div
              className={`flex-shrink-0 w-10 h-10 rounded-lg ${badge.bgColor} flex items-center justify-center text-xl`}
            >
              {badge.emoji}
            </div>
            <div>
              <p className="font-bold text-sm text-[#1a1a1a]" style={{ fontFamily: REG_FONTS.body }}>
                {t(badge.titleKey)}
              </p>
              <p className="text-xs text-[#666] mt-0.5" style={{ fontFamily: REG_FONTS.body }}>
                {t(badge.descKey)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
